import { useState } from 'react';
import { Link } from 'react-router-dom';
import classes from './PublicAuthLinks.module.scss';

const PHONE = '+61 494 017 172';
const PHONE_HREF = 'tel:+61494017172';

const PhoneIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M22 16.92V21a1 1 0 0 1-1.11 1 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 3.19 4.11 1 1 0 0 1 4.18 3h4.09a1 1 0 0 1 1 .75c.12.9.32 1.76.6 2.6a1 1 0 0 1-.22 1.05L7.9 9.16a16 16 0 0 0 6 6l1.76-1.76a1 1 0 0 1 1.05-.22c.84.28 1.7.48 2.6.6a1 1 0 0 1 .69 1z" />
  </svg>
);

// The signed-out header cluster: phone, Sign up, Sign in.
//
// This used to exist three times over — once in Landing, once in
// ServicePage, and as a lone "Sign in" pill in Root for every other
// route. That last one was the odd one out: a visitor on a building page
// got a single pill where the marketing pages gave them the full set.
// One component now serves all three, so there is only one header.
//
// Landing and ServicePage render outside the Root app shell (see
// LANDING_PATHS in Root.tsx), which is why they mount it themselves
// rather than inheriting it from the layout.
const PublicAuthLinks = () => {
  // Tablet and mobile only: the number doesn't fit beside the two pills,
  // so it hides behind its own icon and drops down when tapped.
  const [phoneOpen, setPhoneOpen] = useState(false);

  return (
    <div className={classes.floatingAuth}>
      <a href={PHONE_HREF} className={classes.floatingContact} aria-label="Call Strand Services">
        <span className={classes.floatingContactIcon}>
          <PhoneIcon />
        </span>
        <span>{PHONE}</span>
      </a>
      <div className={classes.contactToggleWrap}>
        <button
          type="button"
          className={classes.contactToggle}
          aria-expanded={phoneOpen}
          aria-label={phoneOpen ? 'Hide phone number' : 'Show phone number'}
          onClick={() => setPhoneOpen((open) => !open)}
        >
          <PhoneIcon />
        </button>
        {phoneOpen && (
          <a href={PHONE_HREF} className={classes.contactReveal}>{PHONE}</a>
        )}
      </div>
      <Link to="/signup" className={classes.floatingSignUp}>Sign up</Link>
      <Link to="/login" className={classes.floatingSignIn}>Sign in</Link>
    </div>
  );
};

export default PublicAuthLinks;
